export const COMFORT_VALUE = {
  WILD: 'wild',
  SIMPLE: 'simple',
  STANDARD: 'standard',
  PREMIUM: 'premium',
} as const;

export type TComfortValue = (typeof COMFORT_VALUE)[keyof typeof COMFORT_VALUE];
export type TComfort = Array<TComfortValue>;
